import Splide from "@splidejs/splide";
import Acpects from "./aspects";
import Headroom from "headroom.js";
import Swiper, {
    Navigation,
    Pagination,
    Autoplay,
    EffectFade
} from "swiper";
Swiper.use(Navigation);
Swiper.use(Pagination);
Swiper.use(Autoplay);
Swiper.use(EffectFade);
const APP = {
    initHeadroom() {
        const stickElem = document.getElementById("stick");
        if (stickElem) {
            new Headroom(stickElem, {
                offset: stickElem.offsetTop + 100
            }).init();
        }
    },
    initSlider() {
        new Swiper("#slider", {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            effect: 'fade',     
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".slider-nav--next",
                prevEl: ".slider-nav--prev",
                disabledClass: "slider-nav--hidden"
            },
            pagination: {
                el: ".slider-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<span class="slider-pagination--item ' +
                        className +
                        '"></span>'
                    );
                }
            }
        });
    },
    initPartnersCarousel() {
        if (document.querySelector(".carousel")) {
            new Splide(".carousel", {
                type: "loop", //slide
                pagination: false,
                loop: false,
                perPage: 5,
                autoplay: false,
                interval: 5000,
                pauseOnHover: true,
                autoplay:true,
                interval:3000,
                rewind: true,
                perMove: 1,
                gap: 10,
                easing: "cubic-bezier(0.61, 1, 0.88, 1)",
                breakpoints: {
                    1024: {
                        perPage: 4
                    },
                    960: {
                        perPage: 3
                    },
                    768: {
                        perPage: 2
                    },
                    560: {
                        perPage: 1
                    }
                }
            }).mount();
        }
    },
    corporateCheck() {
        const corporate = document.getElementById("corporate-check");
        if (corporate) {
            corporate.addEventListener("change", () => {
                document
                    .getElementById("corporate-data")
                    .classList.toggle("hidden");
            });
        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    APP.initHeadroom();
    APP.initSlider();
    APP.initPartnersCarousel();
    APP.corporateCheck();
    Acpects.init();
});
